/* Oergezond sticky ATC: toont zich als de echte ATC boven het scherm is weggescrold.
   Klik = klik op de echte ATC, zodat Kaching de gekozen bundel en geuren toevoegt. */
(function () {
  var bar = document.getElementById('lx-satc');
  var atc = document.querySelector('.product-form__submit');
  if (!bar || !atc) return;
  var btn = bar.querySelector('[data-lx-satc-btn]');
  var sub = bar.querySelector('[data-lx-satc-sub]');
  var past = false;

  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function info() {
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    if (sel) {
      var t = txt(sel.querySelector('.kaching-bundles__bar-title'));
      var p = txt(sel.querySelector('.kaching-bundles__bar-price'));
      sub.textContent = [t, p].filter(Boolean).join(' · ');
    } else {
      var pr = document.querySelector('.product .price-item--sale, .product .price-item--regular');
      sub.textContent = txt(pr);
    }
    btn.disabled = atc.disabled;
    btn.textContent = atc.disabled ? 'Uitverkocht' : 'In winkelwagen';
  }
  function show(on) {
    bar.classList.toggle('lx-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  new IntersectionObserver(function (es) {
    var e = es[0];
    past = !e.isIntersecting && e.boundingClientRect.top < 0; // pas tonen als je voorbij de ATC bent
    if (past) info();
    show(past);
  }).observe(atc);

  btn.addEventListener('click', function () {
    if (atc.disabled) return;
    atc.click();
  });

  // gekozen bundel bijhouden zonder de hele pagina te observeren
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.kaching-bundles__block')) setTimeout(info, 60);
  });
  document.addEventListener('change', function () { setTimeout(info, 60); });
})();
